import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  logoVariants,
  slide_bounce_variants
} from "shared/components/animations";
import promptIcon from "assets/images/gah/prompt.png";
import rectBig from "assets/images/gah/rectangle-big.png";

const PlayingCommon = ({ prompt, playerObj, onSelectCard, gah_new_card }) => {
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="playing-common"
    >
      <motion.div variants={logoVariants} className="big-top-banner">
        <img alt="" src={rectBig} className="rect-big" />
        <div className="prompt-div">
          <h2>{prompt}</h2>
        </div>
        <img alt="" src={promptIcon} className="prompt" />
      </motion.div>

      <motion.div
        variants={slide_bounce_variants}
        className="gifs-container playing"
      >
        {playerObj.cards.map((card, index) => (
          <div key={index} className="common-card-wrapper flip">
            <div className="title-div">
              <h2>{card.text}</h2>
            </div>

            <div className="gif-div flip">
              <img alt="" src={card.gif_url} />
            </div>

            {gah_new_card.active !== null && (
              <div className="flip-div" onClick={() => onSelectCard(card)}>
                <div className="button-border-div" />
                <h2>PLAY</h2>
              </div>
            )}
          </div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default PlayingCommon;
